// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import ToolbarHeader from './layout/ToolbarHeader';
import If from './If';
interface StaticHeaderFormProps extends ReactProps {
    title: string;
    cancelOnClick?: any;
    cancelBtnId?: string;
    cancelDisabled?: boolean;
    saveOnClick?: any;
    saveBtnId?: string;
    saveDisabled?: boolean;
    deleteOnClick?: any;
    deleteBtnId?: string;
    deleteDisabled?: boolean;
    customOnClick?: any;
    customBtnId?: string;
    customBtnText?: string;
    customDisabled?: boolean;
    isActionInProgress?: boolean;
    inProgressMessage?: string;
}

const StaticHeaderForm = (props: StaticHeaderFormProps) => (
    <div className="panel panel-primary fc-expand-last static-header-form">
        <ToolbarHeader title={props.title}>
            <If condition={props.isActionInProgress} class="message">
                {props.inProgressMessage}
            </If>
            <If condition={props.customOnClick}>
                <a id={props.customBtnId} className={`btn btn-primary ${props.customDisabled ? "disabled" : ""}`} onClick={props.customOnClick}>{props.customBtnText}</a>
            </If>
            <If condition={props.deleteOnClick}>
                <a id={props.deleteBtnId} className={`btn btn-danger ${props.deleteDisabled ? "disabled" : ""}`} onClick={props.deleteOnClick}>{InovxLoader.t("common:form.delete")}</a>
            </If>
            <If condition={props.saveOnClick}>
                <a id={props.saveBtnId} className={`btn btn-primary ${props.saveDisabled ? "disabled" : ""}`} onClick={props.saveOnClick}>{InovxLoader.t("common:form.save")}</a>
            </If>
            <If condition={props.cancelOnClick}>
                <a id={props.cancelBtnId} className={`btn btn-default ${props.cancelDisabled ? "disabled" : ""}`} onClick={props.cancelOnClick}>{InovxLoader.t("common:form.cancel") }</a>
            </If>
            
        </ToolbarHeader>
        <div className="shf-content">
            <div className="ctnt-main fc-margin">
                {props.children}
            </div>
        </div>
    </div>
);

export default StaticHeaderForm;